import React from 'react';
import ReactDOM from 'react-dom';
import Template from './pages/Home';
ReactDOM.render(
    <>
       <Template/>
    </>,
  document.getElementById('root')
);

